import { render, staticRenderFns } from "./Graduation.vue?vue&type=template&id=5f56621e&scoped=true"
import script from "./Graduation.vue?vue&type=script&lang=js"
export * from "./Graduation.vue?vue&type=script&lang=js"
import style0 from "./Graduation.vue?vue&type=style&index=0&id=5f56621e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f56621e",
  null
  
)

export default component.exports